// AppErrorBoundary — B-1b (MONIT 2026-09-12_1750, F5 wyzwalacz 4; FAZA A pkt A5: aplikacja NIE
// miała ErrorBoundary — błąd renderu = biały ekran bez wyjścia). Minimalny: fallback z
// „Przeładuj" + „Wyślij diagnostykę do centrali"; błąd leci automatycznie jako shell_error
// (limit 30 min per powód w fleet.js). Kolejka zdjęć w IDB nie jest dotykana.

import { Component } from 'react';
import { reportShellError, sendDiagnostics } from '../../services/fleet.js';
import { APP_VERSION } from '../../shared/appVersion.js';
import { t } from '../../shared/i18n.js';

export default class AppErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null, sent: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    reportShellError('ErrorBoundary', error, { componentStack: String(info?.componentStack || '').slice(0, 1500) })
      .then((r) => this.setState({ sent: r?.status || null }))
      .catch(() => {});
  }

  render() {
    if (!this.state.error) return this.props.children;
    const msg = String(this.state.error?.message || this.state.error || t('errb.unknown')).slice(0, 300);
    return (
      <div data-error-boundary="1" style={{
        minHeight: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
        background: '#101012', color: '#fff', padding: 24, textAlign: 'center',
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
      }}>
        <div style={{ fontSize: 40, marginBottom: 10 }} aria-hidden="true">⚠</div>
        <div style={{ fontSize: 18, fontWeight: 700, marginBottom: 6 }}>{t('errb.title')}</div>
        <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.7)', maxWidth: 320, lineHeight: 1.45, marginBottom: 18 }}>
          {t('errb.body')}
        </div>
        <button onClick={() => { try { window.location.reload(); } catch { /* nic */ } }} style={{
          width: '100%', maxWidth: 320, padding: '15px 20px', borderRadius: 14, marginBottom: 10,
          background: '#eab308', color: '#111', border: 'none', fontSize: 16, fontWeight: 800, cursor: 'pointer',
        }}>{t('errb.reload')}</button>
        <button onClick={() => sendDiagnostics('manual', { extra: { source: 'ErrorBoundary-manual', message: msg } }).then((r) => this.setState({ sent: r?.status || 'failed' }))} style={{
          width: '100%', maxWidth: 320, padding: '12px 20px', borderRadius: 14,
          background: 'transparent', color: '#eab308', border: '1.5px solid #eab308', fontSize: 14, fontWeight: 700, cursor: 'pointer',
        }}>{this.state.sent === 'sent' ? t('errb.sent') : this.state.sent === 'queued' ? t('errb.queued') : t('errb.send')}</button>
        <div style={{ marginTop: 16, fontSize: 10.5, color: 'rgba(255,255,255,0.4)', fontFamily: 'monospace', wordBreak: 'break-word', maxWidth: 340 }}>
          {APP_VERSION} · {msg}
        </div>
      </div>
    );
  }
}
